import { get_token } from "@/router";
import Swal from "sweetalert2";
import { get_tag_style } from "@/utils/task_tags";

const PRIORITY_TONES = [
  { keywords: ['urgent', 'high'], tone: 'high' },
  { keywords: ['important'], tone: 'important' },
  { keywords: ['medium'], tone: 'medium' },
  { keywords: ['low'], tone: 'low' },
];

const priority_label = (priority) => (
  String(priority?.priority_name || priority?.name || priority?.label || '').toLowerCase()
);

export default {
  name: 'Card',
  props: {
    task: Object,
    bucket: Object,
    members: Array,
    buckets: Array,
    statuses: Array,
    priorities: Array,
  },
data() {
  return ({
    searchQuery: '',
    showAssignDropdown: false,
    selectedColumnId: null,
    isMoving: false,
    currentModal: null

  });
},
  mounted(){
    document.addEventListener('click', this.handleClickOutside);

},
beforeUnmount() {
  document.removeEventListener('click', this.handleClickOutside);
},
computed: {
  assigneesArray() {
    return Array.isArray(this.task?.assignees) ? this.task.assignees : [];
  },
  visibleAssignees() {
    return this.assigneesArray.slice(0, 2);
  },
  remainingAssigneeCount() {
    return Math.max(0, this.assigneesArray.length - this.visibleAssignees.length);
  },
  remainingAssigneesTitle() {
    if (this.remainingAssigneeCount <= 0) return '';
    const remaining = this.assigneesArray.slice(this.visibleAssignees.length);
    const names = remaining
      .map(a => a?.portal_access?.base_profile_details?.creater?.full_name)
      .filter(Boolean);
    return names.length ? names.join(', ') : `${this.remainingAssigneeCount} more`;
  },
  normalizedSearchQuery() {
    return String(this.searchQuery || '').toLowerCase().trim();
  },
  filteredAssignees() {
    const assignees = Array.isArray(this.task?.assignees) ? this.task.assignees : [];
    const query = this.normalizedSearchQuery;
    if (!query) return assignees;

    return assignees.filter((assignee) => {
      const fullName = String(
        assignee?.portal_access?.base_profile_details?.creater?.full_name || ''
      ).toLowerCase();
      const email = String(
        assignee?.portal_access?.base_profile_details?.creater?.email || ''
      ).toLowerCase();
      return fullName.includes(query) || email.includes(query);
    });
  },
  filteredSuggestions() {
    const members = Array.isArray(this.members) ? this.members : [];
    const assignees = Array.isArray(this.task?.assignees) ? this.task.assignees : [];

    const assignedUserIds = new Set(
      assignees
        .map((a) => a?.portal_access?.base_profile_details?.creater?.id)
        .filter(Boolean)
    );

    const query = this.normalizedSearchQuery;

    return members.filter((member) => {
      const userId = member?.user?.id;
      if (userId && assignedUserIds.has(userId)) return false;

      if (!query) return true;

      const fullName = String(member?.full_name || '').toLowerCase();
      const email = String(member?.user?.email || '').toLowerCase();
      return fullName.includes(query) || email.includes(query);
    });
  }
},

  methods:{
    getToken() {
        return get_token();
        },
    open_task_modal(task, bucket) {
      this.$emit("open-task-modal", { task, bucket });
    },

    toggleAssignDropdown() {
    this.showAssignDropdown = !this.showAssignDropdown;
    if (this.showAssignDropdown) {
      this.searchQuery = '';
    }
    if (this.$refs.assignmenu) {
      this.$refs.assignmenu.classList.remove('show');
    }
  },
  closeAssignDropdown() {
    this.showAssignDropdown = false;
    this.searchQuery = "";

    this.$nextTick(() => {
      this.$refs.assignDropdown?.classList.remove("show");
    });
  },
 getInitials(name) {
  if (!name || typeof name !== 'string') return '??'; // fallback
  const parts = name.trim().split(' ');
  return parts.map(p => p[0]).join('').toUpperCase().substring(0, 2);
},
  assignUser(member_id, task_id) {
    this.closeAssignDropdown();
    const baseUrl = `${window.location.origin}${this.$route.path}`;
    const encodedReportUrl = encodeURI(`${baseUrl}?task_id=${task_id}`);
    $.ajax({
      url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/assign_users_to_task/`,
      method: "POST",
      data: JSON.stringify({ task_id: task_id, assigned_ids: [member_id] , base_url: encodedReportUrl}),
      headers: {
        "Authorization": `Token ${this.getToken()}`,
        "Content-Type": "application/json"
      },
      success: (response) => {
        if (response.status === "success") {
          this.$emit('task-updated', response.data);
        }
      },
      error: (xhr) => {
        console.error("Error fetching portal members:", xhr);
      },
      complete: () => {
        this.closeAssignDropdown();
      }
    });

  },
   handleClickOutside(event) {
    const dropdown = this.$refs.assignDropdown;
    if (dropdown && !dropdown.contains(event.target)) {
      this.closeAssignDropdown();
    }
  },
  delete_task(task_id){
    Swal.fire({
            title: 'Are you sure?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            position: 'bottom-end',
            toast: true
    }).then((result) => {
            if (result.isConfirmed) {
              $.ajax({
              url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/delete_task/`,
              method: "POST",
              data: JSON.stringify({ task_id: task_id }),
              headers: {
                "Authorization": `Token ${this.getToken()}`,
                "Content-Type": "application/json"
              },
              success: (response) => {
                if (response.status === "success") {
                  this.$emit('task-deleted', task_id);
                }
              },
              error: (xhr) => {
                console.error("Error fetching portal members:", xhr);
              }
            });
          }
          });
    
  },
   removeAssignedUser(member) {
    $.ajax({
          url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/unassign_user_to_task/`,
          method: "POST",
          data: JSON.stringify({ task_assignee_id:member.id }),
          headers: {
            "Authorization": `Token ${this.getToken()}`,
            "Content-Type": "application/json"
          },
          success: (response) => {
            if (response.status === "success") {
            this.$emit('task-updated', response.data);
            }
          },
          error: (xhr) => {
            console.error("Error unassigning portal member:", xhr);
          }
        });
    },

    openMoveTaskModal(task) {

  const currentColumnId = Number(task?.column_id ?? task?.column ?? this.bucket?.id);
  this.selectedColumnId = Number.isFinite(currentColumnId) ? currentColumnId : null; // default column

  const modalEl = document.getElementById(`moveTaskModal-${this.task.id}`);
  const modal = new bootstrap.Modal(modalEl, { backdrop: 'static' })
  modal.show()
  this.currentModal = modal // keep reference to hide later
},

closeMoveModal() {
  if (this.currentModal) {
    this.currentModal.hide()
    this.currentModal = null
  }
},

confirmMoveTask() {
  const currentColumnId = Number(this.task?.column_id ?? this.task?.column ?? this.bucket?.id);
  const targetColumnId = Number(this.selectedColumnId);

  if (!Number.isFinite(targetColumnId) || !Number.isFinite(currentColumnId)) {
    this.closeMoveModal();
    return;
  }

  if (Number.isFinite(currentColumnId) && Number.isFinite(targetColumnId) && targetColumnId === currentColumnId) {
    this.closeMoveModal();
    return;
  }

  this.isMoving = true;

  // 1️⃣ Remove from old column
  const oldColumnIndex = this.buckets.findIndex(c => Number(c.id) === currentColumnId);
  if (oldColumnIndex === -1) {
    this.isMoving = false;
    this.closeMoveModal();
    return;
  }
  const oldColumn = this.buckets[oldColumnIndex];
  const taskIndex = oldColumn.tasks.findIndex(t => t.id === this.task.id);

  if (taskIndex === -1) {
    this.isMoving = false;
    this.closeMoveModal();
    return;
  }

  const [task] = oldColumn.tasks.splice(taskIndex, 1);

  // 2️⃣ Update column_id for task
  task.column_id = targetColumnId;

  // 3️⃣ Add to new column using a new array so Vue detects change
  const newColumnIndex = this.buckets.findIndex(c => Number(c.id) === targetColumnId);
  if (newColumnIndex === -1) {
    oldColumn.tasks = [...oldColumn.tasks.slice(0, taskIndex), task, ...oldColumn.tasks.slice(taskIndex)];
    task.column_id = currentColumnId;
    this.isMoving = false;
    this.closeMoveModal();
    return;
  }
  const newColumn = this.buckets[newColumnIndex];

  // replace tasks array with a new array (reactive)
  const existingNewTasks = Array.isArray(newColumn.tasks) ? newColumn.tasks : [];
  newColumn.tasks = [...existingNewTasks, task];

  // 4️⃣ Persist via API
  $.ajax({
    url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/move_task_to_bucket/`,
    method: "POST",
    data: JSON.stringify({
      task_id: task.id,
      column_id: targetColumnId,
    }),
    headers: {
      Authorization: `Token ${this.getToken()}`,
      "Content-Type": "application/json"
    },
    success: (response) => {
      if (response.status === "success") {
        this.closeMoveModal();
      }
    },
    error: (xhr) => {
      console.error("Error moving task:", xhr);
      newColumn.tasks = newColumn.tasks.filter(t => t.id !== task.id);
      oldColumn.tasks = [...oldColumn.tasks.slice(0, taskIndex), task, ...oldColumn.tasks.slice(taskIndex)];
      task.column_id = oldColumn.id;
    },
    complete: () => {
      this.isMoving = false;
      this.closeMoveModal();
    }
  });
  },
  format_label(text) {
    if (!text) return '';
    return text
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  },
  priority_tone(priority) {
    const label = priority_label(priority);
    const match = PRIORITY_TONES.find(({ keywords }) =>
      keywords.some((keyword) => label.includes(keyword))
    );

    return match?.tone || 'default';
  },
  chip_palette_class(seed, prefix = 'task-chip-tone') {
    const value = String(seed || '').trim();
    const hash = value.split('').reduce((total, char) => total + char.charCodeAt(0), 0);
    return `${prefix}-${hash % 8}`;
  },
  status_chip_class(status) {
    return this.chip_palette_class(status?.id || status?.task_name || status?.name || status?.label);
  },
  tag_style: get_tag_style,
  task_progress_items(task = this.task) {
    const possibleLists = [
      task?.progress,
      task?.progresses,
      task?.progress_list,
      task?.task_progresses,
      task?.progress_statuses,
      task?.statuses
    ];
    const list = possibleLists.find((item) => Array.isArray(item)) || [];
    const progressItems = list.length ? list : (task?.progress ? [task.progress] : []);
    return progressItems.filter((progress) => this.task_progress_name(progress));
  },
  task_progress_name(progress) {
    return [
      progress?.task_name,
      progress?.task_status,
      progress?.name,
      progress?.label
    ].find(Boolean) || '';
  }
  }
};
